export default __webpack_public_path__ + "static/media/discord-img.616fd376.png";